<template>
  <div>
    <el-dialog
      title="请输入验证码"
      :visible="show"
      append-to-body
      width="350px"
      :show-close="false"
    >
      <div class="fm-center">
        <div
          :style="{
            width: width,
            height: height,
            'min-width': width,
            'min-height': height,
            border: '1px solid var(--fm-primary-light-color)',
          }"
          v-loading="imgCaptchaLoading"
        >
          <el-image
            :style="{
              width: width,
              height: height,
            }"
            :src="imgData"
            @click="init"
            v-if="imgData"
          ></el-image>
        </div>

        <div
          class="fm-m-10 fm-flex fm-justifycenter fm-pointer"
          style="height: 1.4em"
          @click="init"
        >
          <i v-fmtype="'primary'" class="el-icon el-icon-refresh fm-mr-5"></i>
          <div v-fmtype="'primary'">点击图片刷新验证码</div>
        </div>
        <el-input
          class="fm-mt-10"
          v-model="inputCode"
          placeholder="请输入验证码"
        ></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-popconfirm
          title="未输入验证码，可能无法进行后续操作，是否继续关闭？"
          @confirm="cancel"
        >
          <el-button slot="reference">关 闭</el-button>
        </el-popconfirm>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebImageCaptchaDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    imgCaptchaTypeEnum: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: "100px",
    },
    height: {
      type: [Number, String],
      default: "50px",
    },
  },
  watch: {
    show: {
      handler(newVal, val) {
        if (newVal) {
          this.$nextTick(() => {
            this.init();
          });
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      imgCaptchaLoading: false,

      key: null,
      imgData: null,

      inputCode: null,
    };
  },

  mounted() {},

  methods: {
    cancel() {
      this.$message({
        message: "未输入验证码，可能无法进行后续操作，如需重新验证请重试",
        type: "error",
      });
      this.$emit("cancel");
    },
    async init(args) {
      this.inputCode = null;
      this.key = null;
      this.imgData = null;
      this.imgCaptchaLoading = true;
      let res = await this.$api.smsRecord_getImgCaptcha(
        {
          imgCaptchaTypeEnum: this.imgCaptchaTypeEnum,
          width: this.width.replace("px", ""),
          height: this.height.replace("px", ""),
        },
        {
          ...args,
        }
      );
      this.imgCaptchaLoading = false;
      if (res && res.success) {
        this.key = res.data.key;
        this.imgData = "data:image/png;base64," + res.data.bytes;
      }
    },
    async confirm() {
      if (!this.inputCode) {
        this.$message({
          message: "请输入验证码",
          type: "error",
        });
        this.$nextTick(() => {
          this.init();
        });
        return;
      }
      let res = await this.$api.smsRecord_checkImgCaptcha({
        imgCaptchaTypeEnum: this.imgCaptchaTypeEnum,
        key: this.key,
        code: this.inputCode,
      });
      if (res && res.success) {
        this.$emit("success", {
          imgCaptchaTypeEnum: this.imgCaptchaTypeEnum,
          key: this.key,
        });
      } else {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/ImageCaptchaDialog.vue